var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    enableBackground: "new 0 0 800 800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE000",
    d: "M644.161,530.032v-1c0-6.563-5.34-11.903-11.903-11.903H24.807V282.871h750.387v234.258h-91.322 c-6.563,0-11.903,5.34-11.903,11.903v1H644.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE000",
    d: "M683.871,516.129h90.322V283.871H25.807v232.258h606.451c7.126,0,12.903,5.777,12.903,12.903h25.807 C670.968,521.906,676.745,516.129,683.871,516.129z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.807,
    y: 153.839,
    fill: "#ED1F34",
    width: 750.387,
    height: 105.226
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.807,
    y: 154.839,
    fill: "#ED1F34",
    width: 748.387,
    height: 103.226
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1F34",
    d: "M24.807,646.161V540.936h607.451c6.563,0,11.903-5.34,11.903-11.903v-1h27.807v1 c0,6.563,5.34,11.903,11.903,11.903h91.322v105.226H24.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1F34",
    d: "M683.871,541.936c-7.126,0-12.903-5.777-12.903-12.903h-25.807c0,7.126-5.777,12.903-12.903,12.903H25.807 v103.226h748.387V541.936H683.871z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.097,129.032H12.903C5.777,129.032,0,134.81,0,141.936v516.129c0,7.126,5.777,12.903,12.903,12.903h774.193 c7.126,0,12.903-5.777,12.903-12.903V141.936C800,134.81,794.223,129.032,787.097,129.032z M774.193,154.839v103.226H25.807 V154.839H774.193z M25.807,645.161V541.936h606.451c7.126,0,12.903-5.777,12.903-12.903s-5.777-12.903-12.903-12.903H25.807 V283.871h748.387v232.258h-90.322c-7.126,0-12.903,5.777-12.903,12.903s5.777,12.903,12.903,12.903h90.322v103.226H25.807z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.6ae9e2f536f0c760f14d4d2e5c5865c1.svg";
export { ForwardRef as ReactComponent };